import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftAvatar from "components/SoftAvatar";
import swal from "sweetalert2";
import bruce from "assets/images/bruce-mars.jpg";
import { api } from "utils/Api";
import EditFormPopup from "layouts/admin/user/data/EditForm";
import DeleteForm from "./DeleteForm";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SmartTableCard from "utils/Smart Table/SmartTableCard";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Organization from "../Organization-detail/Organization";
import AdminAddOrganizationPopup from "./AdminAddToOrg";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { Box, Tooltip } from "@mui/material";
import RemoveFromParentForm from "./MultipleDeleteForm";
import { showSuccess } from "utils/messageAlerts";
import RestoreIcon from "@mui/icons-material/Restore";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ConfirmDialog from "utils/ConfirmDialog";

function UserData() {

  const [users, setUsers] = useState([]);
  const [organization, setOrganization] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMode, setPopupMode] = useState("create");
  const [selectedUser, setSelectedUser] = useState(null);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [isOrgPopupOpen, setIsOrgPopupOpen] = useState(false);
  const [orgFilterAnchor, setOrgFilterAnchor] = useState(null);
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [orgSearch, setOrgSearch] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    type: null,
    user: null,
  });

  useEffect(() => {
    fetchUsers();
    fetchOrganization();
  }, []);

  // Fetch Users
  const fetchUsers = async () => {
    const role_id = 2;
    try {
      const userData = await api.getFiltertedUser.getFiltertedUser({ role_id });
      const formatted = userData.map((u) => ({
        id: u.id,
        username: u.username,
        first_name: u.first_name,
        last_name: u.last_name,
        email: u.email,
        phone_number: u.phone_number,
        description: u.description,
        active: u.active,
        image: u.image || null,
        createdAt: u.created_at,
        organization_id: u.organization_id,
        user_organization: u.user_organization || null,
        role_id: u.role_id,
      }));

      setUsers(formatted);
    } catch (e) {
      setUsers([]);
    }
  };

  const fetchOrganization = async () => {
    try {
        const orgData = await api.su_Organiation.getSuOrgs();
        setOrganization(orgData);
      }
      catch (error) {
      }
    }

  // Edit User
  const handleEditUser = (user) => {
    setPopupMode("edit");
    setSelectedUser(user);
    setIsPopupOpen(true);
  };

  // Delete User
  // const handleDeleteUser = async (userId) => {
  //   try {
  //     await api.Su_User.deleteSuUser(userId);

  //     Swal.fire({
  //       title: "User deleted successfully",
  //       icon: "success",
  //       toast: true,
  //       timer: 2000,
  //       position: "bottom-right",
  //       showConfirmButton: false,
  //     });

  //     fetchUsers();
  //   } catch (err) {
  //     //console.log(err);
  //     swal.fire({
  //       title: "Delete failed",
  //       icon: "error",
  //       toast: true,
  //       timer: 2000,
  //       position: "bottom-right",
  //       showConfirmButton: false,
  //     });
  //   }
  // };


  // User Remove with Organization
  // const handleDeleteUser = async (userId) => {

  //   // Find matched user
  //   const matchedUser = users.find((u) => u.id === userId);

  //   if (!matchedUser) {
  //     console.log("User not found");
  //     return;
  //   }

  //   const payload = {
  //     organization_id : matchedUser.organization_id,
  //     user_role_id : matchedUser.role_id,
  //     user_id : matchedUser.id,
  //   }

  //   try {
  //     await api.su_Organiation.deleteUserFromOrg(payload);

  //     Swal.fire({
  //       title: "User Removed successfully From Organization",
  //       icon: "success",
  //       toast: true,
  //       timer: 2000,
  //       position: "bottom-right",
  //       showConfirmButton: false,
  //     });

  //     fetchUsers();
  //   } catch (err) {
  //     swal.fire({
  //       title: "Delete failed",
  //       icon: "error",
  //       toast: true,
  //       timer: 2000,
  //       position: "bottom-right",
  //       showConfirmButton: false,
  //     });
  //   }
  // };

  const handleDeleteUser = async (payload) => {
    try {
      await api.su_Organiation.deleteUserFromOrg(payload);
      showSuccess("Admin Removed From Organization Successfully.");
      fetchUsers();
    } catch (err) {
      // console.error("Error occurred while removing admin from organization:", err);
    }
  };

  // Search Users
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const filtered = users.filter((user) => {
    const term = searchTerm.toLowerCase();

    const matchesSearch =
      !searchTerm.trim() ||
      user.first_name?.toLowerCase().includes(term) ||
      user.last_name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.username?.toLowerCase().includes(term)

    const matchesOrg = selectedOrgs.length === 0 || user.user_organization?.some((uo) => selectedOrgs.includes(uo.organization_id));

    return matchesSearch && matchesOrg;
  });

  const filteredOrganizations = organization.filter((org) =>
    org.name.toLowerCase().includes(orgSearch.toLowerCase())
  );

  const orgMap = organization.reduce((acc, org) => {
    acc[org.id] = org.name;
    return acc;
  }, {});

  const handleManagerActionClick = (user, action) => {
    setConfirmDialog({
      open: true,
      type: action,
      user,
    });
  };
  const handleAdminActive = async () => {
    const { user, type } = confirmDialog;
    console.log('user: ', user);
    const isDelete = type === "delete";

    try {
      if (isDelete) {
        await api.su_Organiation.hardDeleteOrgUser({
          user_id: user.id,
          organization_id: user.user_organization[0].organization_id,
          user_role_id: 2,
        });
        showSuccess("Admin deleted successfully");
      } else {
        await api.su_Organiation.restoreOrgUser({
          user_id: user.id,
          organization_id: user.user_organization[0].organization_id,
          user_role_id: 2,
        });
        showSuccess("Admin restored successfully");
      }

      fetchUsers();
    } catch (error) {
    }
    setConfirmDialog({ open: false, type: null, user: null });
  };

  return (
    <SmartTableCard
      title={`All Admins`}
      headerRight={[
        // <SoftButton
        //   key="add-btn"
        //   variant="outlined"
        //   color="info"
        //   size="small"
        //   onClick={() => {
        //     setPopupMode("create");
        //     setSelectedUser(null);
        //     setIsPopupOpen(true);
        //   }}
        // >
        //   New User
        // </SoftButton>,
        <SoftButton
          key="add-btn"
          variant="outlined"
          color="info"
          size="small"
          onClick={() => {
            setSelectedUser(null);
            setIsOrgPopupOpen(true);
          }}
        >
          Add User To Organization
        </SoftButton>,

        <SoftInput
          key="search-input"
          placeholder="Search User"
          value={searchTerm}
          onChange={handleSearch}
          size="small"
        />,
      ]}
      columns={[
        // { label: "User", key: "User" },
        { label: "Username", key: "Username", align: "center" },
        { label: "Email", key: "Email", align: "center" },
        { label: "Phone", key: "Phone", align: "center" },
        { label: "Description", key: "Description", align: "center" },
        // {label: "Organization", key: "Organization", align: "center"},
        {
          label: (
            <SoftBox display="flex" alignItems="center" justifyContent="center" gap="4px">
              <span>Organization</span>
              {/* <FilterAltOutlinedIcon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                  color: selectedOrgs.length > 0 ? "#0284C7" : "#475467",
                  "&:hover": {
                    color: "#0284C7",
                  },
                }}
                onClick={(e) => setOrgFilterAnchor(e.currentTarget)}
              /> */}
              <SoftBox position="relative" display="flex" alignItems="center">
                <FilterAltOutlinedIcon
                  fontSize="small"
                  sx={{
                    cursor: "pointer",
                    color: selectedOrgs.length ? "#0284C7" : "#475467",
                    "&:hover": {
                      color: "#0284C7",
                    },
                  }}
                  onClick={(e) => setOrgFilterAnchor(e.currentTarget)}
                />

                {selectedOrgs.length > 0 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: -4,
                      right: -6,
                      background: "#0284C7",
                      color: "#fff",
                      borderRadius: "50%",
                      fontSize: 10,
                      width: 16,
                      height: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {selectedOrgs.length}
                  </Box>
                )}
              </SoftBox>
            </SoftBox>
          ),
          key: "Organization",
          align: "center",
        },
        // { label: "Status", key: "Status", align: "center" },
        { label: "Active", key: "Active", align: "center" },
        { label: "Actions", key: "Actions", align: "center" },
      ]}
      rows={filtered.map((user) => {
        const isActive = user.user_organization.some((j) => j.active === true);
        const isInactive = !isActive;
        // User: (
        //   <SoftBox display="flex" alignItems="center">
        //     {/* <SoftAvatar
        //       src={user.image ? `https://hgpro.nyc${user.image}` : bruce}
        //       variant="rounded"
        //       size="sm"
        //       shadow="sm"
        //     /> */}
        //     &nbsp;
        //     <SoftBox>
        //       <SoftTypography
        //         variant="button"
        //         sx={{ cursor: "pointer", fontWeight: 600 }}
        //       >
        //         {user.first_name} {user.last_name}
        //       </SoftTypography>
        //     </SoftBox>
        //   </SoftBox>
        // ),
        return {
        Username: user.username,
        Email: user.email,
        Phone: user.phone_number,
        Description: user.description,
        Organization: user.user_organization?.length
          ? user.user_organization
              .map((uo) => orgMap[uo.organization_id])
              .filter(Boolean)
              .join(", ")
          : orgMap[user.organization_id] || "N/A",
        Active: isActive ? (
          <SoftTypography variant="button" color="success" fontWeight="bold">
            Yes
          </SoftTypography>
        ) : (
          <SoftBox display="flex" justifyContent="center" gap="6px">
            {/* Restore */}
            <Tooltip title="Restore Unit" arrow>
              <IconButton
                onClick={() => handleManagerActionClick(user, "restore")}
                sx={{
                  width: 30,
                  height: 30,
                  color: "#16A34A",
                  backgroundColor: "#ECFDF5",
                  "&:hover": {
                    backgroundColor: "#D1FAE5",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <RestoreIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>

            {/* Delete */}
            <Tooltip title="Delete Permanently" arrow>
              <IconButton
                onClick={() => handleManagerActionClick(user, "delete")}
                sx={{
                  width: 30,
                  height: 30,
                  color: "#DC2626",
                  backgroundColor: "#FEF2F2",
                  "&:hover": {
                    backgroundColor: "#FEE2E2",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <DeleteForeverIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          </SoftBox>
        ),
        Actions: (
          <SoftBox display="flex" justifyContent="center" gap="8px">
            <IconButton
              onClick={() => handleEditUser(user)}
              disabled={isInactive}
              sx={{
                border: "1px solid #D0D5DD",
                backgroundColor: "#F9FAFB",
                width: 34,
                height: 34,
                "& svg": { fontSize: 18 },
                color: "#475467",
                "&:hover": {
                  backgroundColor: "#E0F2FE",
                  borderColor: "#38BDF8",
                  color: "#0284C7",
                },
              }}
            >
              <EditIcon fontSize="sm" />
            </IconButton>

            <IconButton
              onClick={() => {
                setDeletePopupOpen(true);
                setSelectedUser(user);
              }}
              disabled={isInactive}
              sx={{
                border: "1px solid #FECACA",
                backgroundColor: "#FEF2F2",
                width: 34,
                height: 34,
                "& svg": { fontSize: 18 },
                color: "#B91C1C",
                "&:hover": {
                  backgroundColor: "#FEE2E2",
                  borderColor: "#F87171",
                  color: "#991B1B",
                },
              }}
            >
              <DeleteIcon fontSize="sm" />
            </IconButton>
          </SoftBox>
        ),
      }
      })}
    >
      <ConfirmDialog
        open={confirmDialog.open}
        type={confirmDialog.type}
        title={confirmDialog.type === "delete" ? "Delete Admin" : "Restore Admin"}
        description={
          confirmDialog.type === "delete"
            ? "This will permanently delete the Admin. This action cannot be undone."
            : "Are you sure you want to restore this Admin?"
        }
        confirmText={confirmDialog.type === "delete" ? "Delete Permanently" : "Restore"}
        onClose={() => setConfirmDialog({ open: false, type: null, user: null })}
        onConfirm={handleAdminActive}
      />

      {isOrgPopupOpen && (
        <AdminAddOrganizationPopup
          onClose={() => setIsOrgPopupOpen(false)}
          refreshData={fetchUsers}
        />
      )}
      {isPopupOpen && (
        <EditFormPopup
          mode={popupMode}
          user={selectedUser}
          onClose={() => {
            setIsPopupOpen(false);
            fetchUsers();
          }}
        />
      )}

      {/* {deletePopupOpen && (
        <DeleteForm
          data={selectedUser}
          onClose={() => setDeletePopupOpen(false)}
          onDelete={(id) => {
            handleDeleteUser(id);
            setDeletePopupOpen(false);
          }}
        />
      )} */}
      {deletePopupOpen && (
        <RemoveFromParentForm
          open={deletePopupOpen}
          entity={selectedUser}
          entityLabel="Admin"
          parentLabel="Organization"
          assignments={selectedUser?.user_organization}
          parentKey="organization_id"
          parentMap={orgMap}
          onClose={() => setDeletePopupOpen(false)}
          onRemove={(organization_id, user) => {
            handleDeleteUser({
              organization_id,
              user_id: user.id,
              user_role_id: 2,
            });
            setDeletePopupOpen(false);
          }}
        />
      )}

      {/* <Menu
        anchorEl={orgFilterAnchor}
        open={Boolean(orgFilterAnchor)}
        onClose={() => setOrgFilterAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {organization.map((org) => (
          <MenuItem
            key={org.id}
            onClick={() => {
              if (selectedOrgs.includes(org.id)) {
                setSelectedOrgs(selectedOrgs.filter((id) => id !== org.id));
              } else {
                setSelectedOrgs([...selectedOrgs, org.id]);
              }
            }}
          >
            <Checkbox checked={selectedOrgs.includes(org.id)} />
            <ListItemText primary={org.name} />
          </MenuItem>
        ))}

        {organization.length === 0 && <MenuItem disabled>No Organizations</MenuItem>}
      </Menu> */}
      <Menu
        anchorEl={orgFilterAnchor}
        open={Boolean(orgFilterAnchor)}
        onClose={() => setOrgFilterAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {/* Header: Search + Close */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          px={1}
          py={1}
          gap={1}
        >
          <SoftInput
            placeholder="Search organization"
            size="small"
            value={orgSearch}
            onChange={(e) => setOrgSearch(e.target.value)}
          />

          <IconButton
            size="small"
            onClick={() => setOrgFilterAnchor(null)}
            onClose={() => {
              setOrgFilterAnchor(null);
              setOrgSearch("");
            }}
          >
            ✕
          </IconButton>
        </Box>

        {/* Clear Selection */}
        {selectedOrgs.length > 0 && (
          <MenuItem onClick={() => setSelectedOrgs([])} sx={{ color: "#0284C7", fontWeight: 600 }}>
            Clear Selection
          </MenuItem>
        )}

        {/* Organization List */}
        {filteredOrganizations.length > 0 ? (
          filteredOrganizations.map((org) => (
            <MenuItem
              key={org.id}
              onClick={() => {
                if (selectedOrgs.includes(org.id)) {
                  setSelectedOrgs(selectedOrgs.filter((id) => id !== org.id));
                } else {
                  setSelectedOrgs([...selectedOrgs, org.id]);
                }
              }}
            >
              <Checkbox checked={selectedOrgs.includes(org.id)} />
              <ListItemText primary={org.name} primaryTypographyProps={{ variant: "body3" }} />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No organizations found</MenuItem>
        )}
      </Menu>
    </SmartTableCard>
  );
}

export default UserData;